/**
* Flower page - Products Carousels
*/

const flowerSplide = () => {
  const prodItems = document.querySelectorAll<HTMLElement>( '.js-flower-prod-carousel' );

  prodItems.forEach(item => {
    //@ts-ignore
    new Splide(item, {
      pagination: false,
      type   : 'loop',
    }).mount()
  });
}

export default flowerSplide